export default "__VITE_ASSET__BuP7_lvy__"